(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["df-signature-guide"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-df-material]');
  if(!button)return;
  const section=button.closest('.df-signature-guide');
  section.querySelectorAll('[data-df-material]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  section.querySelectorAll('[data-df-bag-material]').forEach(card=>card.hidden=button.dataset.dfMaterial!=='all'&&card.dataset.dfBagMaterial!==button.dataset.dfMaterial);
  section.querySelector('.df-signature-guide__cards').scrollLeft=0;
});

  } catch(e) { console.error(e); }
})();
})();
